import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'model',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: 'model',
    method: 'get',
    params: queriesParams
  })
}

export function addModel (model) {
  return request({
    method: 'post',
    url: 'model',
    data: model
  })
}

export function show (id) {
  return request({
    url: `model/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `model/${id}`,
    method: 'patch',
    data
  })
}
